export const appType = 'main'; // 'club'; //
export const clubId = null; //310510386; //
export const organizerId = null;

export const MygolfServerHost = 'betalet.mygolf2u.com';
// export const MygolfServerHost = 'clslet.mygolf2u.com';
export const MygolfSSLEnable = true;

export const OneSignalAppID = '8a23eb44-fcac-4899-a4e4-2ce8fbd9851a'; //prod
// export const OneSignalAppID = '8a9a6dd5-c0ea-4de7-9cc7-c8c713ddd4c0'; //class

export const environment = 'prod';

export const devMode = false;
export const testClubID = 310510379; //1808271420;
export const testClubName = 'Penang Golf Club';
export const testPartnerID = 'AGSSG';

export const enableChat = false;
export const chatServer = 'betachat.mygolf2u.com';
export const chatPort = '11014';
export const filterNewsPromoByDates = false;
